export default {
  example_title: 'Example',
  luoleAdmin_navigation: 'Recruitment Backend',
  luoleAdmin_menu_enterpriseList: 'Enterprise List',
  luoleAdmin_menu_enterpriseUsers: 'Enterprise Users',
  luoleAdmin_menu_enterpriseVerify: 'Enterprise Verification',
  luoleAdmin_menu_talentManagement: 'Talent Management',
  luoleAdmin_menu_talentPool: 'Talent Pool',
  luoleAdmin_menu_resumePool: 'Resume Pool',
  luoleAdmin_menu_resumeLibrary: 'Resume Library',
  luoleAdmin_menu_recruitmentManagement: 'Recruitment Management',
  luoleAdmin_menu_jobManagement: 'Job Management',
  luoleAdmin_menu_applicationManagement: 'Application Management',
  luoleAdmin_menu_talentRecommendation: 'Talent Recommendation',
  luoleAdmin_menu_dictionary: '職種カテゴリ',
  luoleAdmin_menu_jobCategories: 'Job Categories',
  luoleAdmin_menu_resumeTemplateManagement: 'Resume Template Management',
  luoleAdmin_dashboard: 'Dashboard',
  luoleAdmin_menu_home: 'Home',
  luoleAdmin_menu_chat: 'Chat',
  luoleAdmin_menu_communication: 'Communication',
  luoleAdmin_menu_jobApplication: 'Job Application',
  luoleAdmin_userManagement: 'User Management',
  luoleAdmin_companyManagement: 'Company Management',
  luoleAdmin_hunterManagement: 'Hunter Management',
  luoleAdmin_candidateManagement: 'Candidate Management',
  luoleAdmin_orderManagement: 'Order Management',
  luoleAdmin_financeManagement: 'Finance Management',
  luoleAdmin_systemSettings: 'System Settings',
  luoleAdmin_menu_rolePermissions: 'ロール権限',
  luoleAdmin_reports: 'Reports & Statistics',
  luoleAdmin_common_search: 'Search',
  luoleAdmin_common_filter: 'Filter',
  luoleAdmin_common_export: 'Export',
  luoleAdmin_common_import: 'Import',
  luoleAdmin_common_refresh: 'Refresh',
  luoleAdmin_common_save: 'Save',
  luoleAdmin_common_cancel: 'Cancel',
  luoleAdmin_common_close: 'Close',
  luoleAdmin_common_empty: 'No data available',
  luoleAdmin_common_confirm: 'Confirm',
  luoleAdmin_common_delete: 'Delete',
  luoleAdmin_common_edit: 'Edit',
  luoleAdmin_common_view: 'View',
  luoleAdmin_common_add: 'Add',
  luoleAdmin_common_status: 'Status',
  luoleAdmin_common_priority: 'Priority',
  luoleAdmin_common_success: 'Success',
  luoleAdmin_common_failed: 'Failed',
  luoleAdmin_common_must_be_image: 'must be an image',
  luoleAdmin_common_size_limit: 'File size must be less than',
  luoleAdmin_common_date: 'Date',
  luoleAdmin_common_actions: 'Actions',
  luoleAdmin_dashboard_error:
    'Failed to load dashboard data, fallback metrics are displayed.',
  luoleAdmin_dashboard_error_title: 'Warning',
  luoleAdmin_dashboard_retry: 'Retry',
  luoleAdmin_dashboard_title: 'Data Overview',
  luoleAdmin_dashboard_subtitle: 'Monitor recruitment KPIs in real time.',
  luoleAdmin_dashboard_card_enterprise: 'Total Enterprises',
  luoleAdmin_dashboard_card_talent: 'Total Talents',
  luoleAdmin_dashboard_card_job: 'Total Jobs',
  luoleAdmin_dashboard_card_application: 'Total Applications',
  luoleAdmin_dashboard_label_active: 'Active',
  luoleAdmin_dashboard_label_verified: 'Verified',
  luoleAdmin_dashboard_label_resume: 'Resume completion',
  luoleAdmin_dashboard_label_published: 'Published',
  luoleAdmin_dashboard_label_today: 'Today',
  luoleAdmin_dashboard_label_week: 'This week',
  luoleAdmin_dashboard_label_conversion: 'Conversion',
  luoleAdmin_dashboard_table_enterprise_name: 'Enterprise',
  luoleAdmin_dashboard_table_created_at: 'Created at',
  luoleAdmin_dashboard_table_candidate: 'Candidate',
  luoleAdmin_dashboard_table_job: 'Job title',
  luoleAdmin_dashboard_table_applied_at: 'Applied at',
  luoleAdmin_dashboard_trend_title: 'Trend (last 30 days)',
  luoleAdmin_dashboard_empty: 'No data',
  luoleAdmin_dashboard_enterprise_analysis: 'Enterprise analysis',
  luoleAdmin_dashboard_status_distribution: 'Status distribution',
  luoleAdmin_dashboard_industry_distribution: 'Industry distribution',
  luoleAdmin_dashboard_application_analysis: 'Application analysis',
  luoleAdmin_dashboard_conversion: 'Conversion',
  luoleAdmin_dashboard_conversion_total: 'Overall conversion rate',
  luoleAdmin_dashboard_conversion_success: 'Success rate',
  luoleAdmin_dashboard_job_category: 'Job category distribution',
  luoleAdmin_dashboard_job_location: 'Job location distribution',
  luoleAdmin_dashboard_recent_enterprise: 'Latest enterprises',
  luoleAdmin_dashboard_recent_application: 'Latest applications',
  luoleAdmin_dashboard_status_active: 'Active',
  luoleAdmin_dashboard_status_inactive: 'Inactive',
  luoleAdmin_dashboard_status_pending: 'Pending',
  luoleAdmin_dashboard_application_applied: 'Applied',
  luoleAdmin_dashboard_application_screening: 'Screening',
  luoleAdmin_dashboard_application_interviewing: 'Interviewing',
  luoleAdmin_dashboard_application_offered: 'Offered',
  luoleAdmin_dashboard_application_accepted: 'Accepted',
  luoleAdmin_dashboard_application_rejected: 'Rejected',
  luoleAdmin_dashboard_chart_enterprise: 'Enterprise',
  luoleAdmin_dashboard_chart_talent: 'Talent',
  luoleAdmin_dashboard_chart_job: 'Job',
  luoleAdmin_dashboard_chart_application: 'Application',
  luoleAdmin_dashboard_go_ops: '運営ダッシュボードへ',
  luoleAdmin_recruitmentOps_kpi_enterpriseTotal: '企業総数',
  luoleAdmin_recruitmentOps_kpi_publishedEnterprise: '掲載企業数',
  luoleAdmin_recruitmentOps_kpi_talentTotal: '人材総数',
  luoleAdmin_recruitmentOps_kpi_publishedJobs: '公開求人総数',
  luoleAdmin_recruitmentOps_kpi_jobPostingApplications: '求人応募総数',
  luoleAdmin_recruitmentOps_kpi_interviewTotal: '面接総数',
  luoleAdmin_recruitmentOps_kpi_offerTotal: 'Offer 総数',
  luoleAdmin_recruitmentOps_kpi_offerAcceptedTotal: 'Offer 承諾数',
  luoleAdmin_recruitmentOps_filter_tenant: '企業選択（名称検索可）',
  luoleAdmin_recruitmentOps_filter_organization: '企業を選択',
  luoleAdmin_recruitmentOps_filter_keyword: 'キーワード（求人/候補者/企業）',
  luoleAdmin_recruitmentOps_filter_status: 'ステータス',
  luoleAdmin_recruitmentOps_tab_jobs: '求人一覧',
  luoleAdmin_recruitmentOps_tab_applications: '応募一覧',
  luoleAdmin_recruitmentOps_jobs_title: '求人名',
  luoleAdmin_recruitmentOps_jobs_company: '企業名',
  luoleAdmin_recruitmentOps_jobs_publishedAt: '公開日時',
  luoleAdmin_recruitmentOps_jobs_applicationCount: '応募数',
  luoleAdmin_recruitmentOps_jobs_location: '勤務地',
  luoleAdmin_recruitmentOps_jobs_recruiter: '作成者',
  luoleAdmin_recruitmentOps_backfill_button: '作成者を一括補完',
  luoleAdmin_recruitmentOps_backfill_confirm_title: '作成者一括補完の確認',
  luoleAdmin_recruitmentOps_backfill_confirm_content:
    '現在のスコープ（{{scope}}）で求人の作成者/更新者/所有者を補完します。続行しますか？',
  luoleAdmin_recruitmentOps_backfill_scope_all: '全体',
  luoleAdmin_recruitmentOps_backfill_success:
    '補完完了: 求人 {{updatedJobTotal}} 件を更新、企業 {{updatedTenantTotal}} 件に反映、企業 {{skippedTenantTotal}} 件をスキップ',
  luoleAdmin_recruitmentOps_app_candidate: '候補者',
  luoleAdmin_recruitmentOps_app_job: '求人',
  luoleAdmin_recruitmentOps_app_appliedDate: '応募日時',
  luoleAdmin_recruitmentOps_app_source: 'ソース',
  luoleAdmin_recruitmentOps_interview_modal_title: '面接詳細',
  luoleAdmin_recruitmentOps_interview_candidate: '候補者',
  luoleAdmin_recruitmentOps_interview_job: '求人',
  luoleAdmin_recruitmentOps_interview_title: '面接タイトル',
  luoleAdmin_recruitmentOps_interview_time: '面接日時',
  luoleAdmin_enterpriseList_title: 'Enterprise Directory',
  luoleAdmin_enterpriseList_subtitle:
    'Manage company accounts, verify information and maintain contacts.',
  luoleAdmin_enterpriseList_search_placeholder: 'Search by company or contact',
  luoleAdmin_enterpriseList_status_placeholder: 'Filter by status',
  luoleAdmin_enterpriseList_status_all: 'All statuses',
  luoleAdmin_enterpriseList_status_active: 'Active',
  luoleAdmin_enterpriseList_status_inactive: 'Inactive',
  luoleAdmin_enterpriseList_status_pending: 'Pending',
  luoleAdmin_enterpriseList_add: 'Add enterprise',
  luoleAdmin_enterpriseList_batch_delete: 'Delete ({{count}}) selected',
  luoleAdmin_enterpriseList_load_failed: 'Failed to load enterprise list.',
  luoleAdmin_enterpriseList_load_detail_failed:
    'Failed to load enterprise detail.',
  luoleAdmin_enterpriseList_action_view: 'View detail',
  luoleAdmin_enterpriseList_action_downloadMiniProgramCode:
    'ミニプログラムコードをダウンロード',
  luoleAdmin_enterpriseList_action_edit: 'Edit',
  luoleAdmin_enterpriseList_action_delete: 'Delete',
  luoleAdmin_enterpriseList_downloadMiniProgramCode_success:
    'ミニプログラムコードのダウンロードに成功しました',
  luoleAdmin_enterpriseList_downloadMiniProgramCode_failed:
    'ミニプログラムコードのダウンロードに失敗しました',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCode:
    'ミニプログラムコードを一括ダウンロード（Excel）',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCode_success:
    '一括ダウンロードに成功しました',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCode_failed:
    '一括ダウンロードに失敗しました',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCodeZip:
    '画像パックを一括ダウンロード（ZIP）',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCodeZip_success:
    '画像パックのダウンロードに成功しました',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCodeZip_failed:
    '画像パックのダウンロードに失敗しました',
  luoleAdmin_enterpriseList_delete_confirm:
    'Are you sure you want to delete this enterprise?',
  luoleAdmin_enterpriseList_delete_success: 'Deleted successfully',
  luoleAdmin_enterpriseList_delete_failed: 'Delete failed',
  luoleAdmin_enterpriseList_update_success: 'Updated successfully',
  luoleAdmin_enterpriseList_create_success: 'Created successfully',
  luoleAdmin_enterpriseList_save_failed: 'Save failed',
  luoleAdmin_enterpriseList_batch_empty:
    'Select at least one enterprise first.',
  luoleAdmin_enterpriseList_missing_id: 'Enterprise ID is missing.',
  luoleAdmin_enterpriseList_column_name: 'Enterprise',
  luoleAdmin_enterpriseList_column_industry: 'Industry',
  luoleAdmin_enterpriseList_column_scale: 'Scale',
  luoleAdmin_enterpriseList_column_contact: 'Contact',
  luoleAdmin_enterpriseList_column_creator: 'Created by',
  luoleAdmin_enterpriseList_column_creatorPhone: 'Creator phone',
  luoleAdmin_enterpriseList_column_created: 'Created at',
  luoleAdmin_enterpriseList_pagination_total:
    '{start}-{end} of {total} records',
  luoleAdmin_enterpriseList_modal_create: 'Create enterprise',
  luoleAdmin_enterpriseList_modal_edit: 'Edit enterprise',
  luoleAdmin_enterpriseList_form_required: 'This field is required.',
  luoleAdmin_enterpriseList_form_name: 'Enterprise name',
  luoleAdmin_enterpriseList_form_name_placeholder: 'Enter enterprise name',
  luoleAdmin_enterpriseList_form_industry: 'Industry',
  luoleAdmin_enterpriseList_form_industry_placeholder: 'Enter industry',
  luoleAdmin_enterpriseList_form_scale: 'Company size',
  luoleAdmin_enterpriseList_form_scale_placeholder: 'Enter company size',
  luoleAdmin_enterpriseList_form_contact: 'Contact person',
  luoleAdmin_enterpriseList_form_contact_placeholder: 'Enter contact person',
  luoleAdmin_enterpriseList_form_phone: 'Phone',
  luoleAdmin_enterpriseList_form_phone_placeholder: 'Enter phone number',
  luoleAdmin_enterpriseList_form_email: 'Email',
  luoleAdmin_enterpriseList_form_email_placeholder: 'Enter email address',
  luoleAdmin_enterpriseList_form_email_invalid: 'Enter a valid email.',
  luoleAdmin_enterpriseList_form_address: 'Address',
  luoleAdmin_enterpriseList_form_address_placeholder: 'Enter company address',
  luoleAdmin_enterpriseList_form_remark: 'Remark',
  luoleAdmin_enterpriseList_form_remark_placeholder: 'Enter additional notes',
  luoleAdmin_enterpriseCreate_page_description:
    'Fill in the enterprise information below to add a new enterprise.',
  luoleAdmin_enterpriseCreate_page_description_edit:
    'Modify the enterprise information below.',
  luoleAdmin_enterpriseDetail_load_failed: 'Failed to load enterprise detail.',
  luoleAdmin_enterpriseDetail_back: 'Back to list',
  luoleAdmin_enterpriseDetail_edit: 'Edit',
  luoleAdmin_enterpriseDetail_subtitle:
    'Complete profile and contact information.',
  luoleAdmin_enterpriseDetail_basic: 'Basic information',
  luoleAdmin_enterpriseDetail_id: 'Enterprise ID',
  luoleAdmin_enterpriseDetail_created: 'Created at',
  luoleAdmin_enterpriseDetail_updated: 'Updated at',
  luoleAdmin_enterpriseDetail_empty:
    'Enterprise does not exist or has been removed.',
  common_comingSoon: 'This feature is under active migration.',
  luoleAdmin_enterpriseUsers_title: 'Enterprise Users',
  luoleAdmin_enterpriseUsers_description:
    'Manage enterprise member accounts, roles and permissions.',
  luoleAdmin_enterpriseUsers_stat_total: 'Total members',
  luoleAdmin_enterpriseUsers_stat_active: 'Active',
  luoleAdmin_enterpriseUsers_stat_pending: 'Pending approval',
  luoleAdmin_enterpriseUsers_search_placeholder: 'Search name, email or phone',
  luoleAdmin_enterpriseUsers_status_placeholder: 'Filter by status',
  luoleAdmin_enterpriseUsers_status_suspended: 'Suspended',
  luoleAdmin_enterpriseUsers_role_placeholder: 'Filter by role',
  luoleAdmin_enterpriseUsers_role_all: 'All roles',
  luoleAdmin_enterpriseUsers_load_failed: 'Failed to load member list.',
  luoleAdmin_enterpriseUsers_detail_failed: 'Failed to load member detail.',
  luoleAdmin_enterpriseUsers_update_success: 'Member updated successfully.',
  luoleAdmin_enterpriseUsers_update_failed: 'Failed to update member.',
  luoleAdmin_enterpriseUsers_delete_success: 'Member deleted successfully.',
  luoleAdmin_enterpriseUsers_delete_failed: 'Failed to delete member.',
  luoleAdmin_enterpriseUsers_missing_id: 'Member ID is missing.',
  luoleAdmin_enterpriseUsers_action_view: 'View detail',
  luoleAdmin_enterpriseUsers_action_edit: 'Edit',
  luoleAdmin_enterpriseUsers_action_delete: 'Delete',
  luoleAdmin_enterpriseUsers_action_activate: 'Activate',
  luoleAdmin_enterpriseUsers_action_deactivate: 'Deactivate',
  luoleAdmin_enterpriseUsers_action_lock: 'Lock login',
  luoleAdmin_enterpriseUsers_action_unlock: 'Unlock login',
  luoleAdmin_enterpriseUsers_action_result_activate: 'Member activated',
  luoleAdmin_enterpriseUsers_action_result_deactivate: 'Member deactivated',
  luoleAdmin_enterpriseUsers_action_result_lock: 'Member locked',
  luoleAdmin_enterpriseUsers_action_result_unlock: 'Member unlocked',
  luoleAdmin_enterpriseUsers_delete_confirm: 'Delete this member?',
  luoleAdmin_enterpriseUsers_batch_confirm: 'Delete selected members?',
  luoleAdmin_enterpriseUsers_batch_delete: 'Delete ({{count}}) selected',
  luoleAdmin_enterpriseUsers_batch_delete_success: 'Deleted {{count}} members.',
  luoleAdmin_enterpriseUsers_table_member: 'Member',
  luoleAdmin_enterpriseUsers_table_contact: 'Contact',
  luoleAdmin_enterpriseUsers_table_company: 'Enterprise',
  luoleAdmin_enterpriseUsers_table_role: 'Role',
  luoleAdmin_enterpriseUsers_table_lastLogin: 'Last login',
  luoleAdmin_enterpriseUsers_modal_title: 'Edit member',
  luoleAdmin_enterpriseUsers_form_role: 'Role',
  luoleAdmin_enterpriseUsers_form_role_placeholder: 'Select role',
  luoleAdmin_enterpriseUsers_form_role_required: 'Role is required',
  luoleAdmin_enterpriseUsers_form_status: 'Status',
  luoleAdmin_enterpriseUsers_form_status_placeholder: 'Select status',
  luoleAdmin_enterpriseUsers_form_status_required: 'Status is required',
  luoleAdmin_enterpriseUsers_form_position: 'Position',
  luoleAdmin_enterpriseUsers_form_position_placeholder: 'Enter position',
  luoleAdmin_enterpriseUsers_form_employeeId: 'Employee ID',
  luoleAdmin_enterpriseUsers_form_employeeId_placeholder: 'Enter employee ID',
  luoleAdmin_enterpriseUsers_detail_title: 'Member detail',
  luoleAdmin_enterpriseUsers_detail_empty: 'No detail data.',
  luoleAdmin_enterpriseUsers_label_username: 'Username',
  luoleAdmin_enterpriseUsers_label_realName: 'Real name',
  luoleAdmin_enterpriseUsers_label_email: 'Email',
  luoleAdmin_enterpriseUsers_label_phone: 'Phone',
  luoleAdmin_enterpriseUsers_label_role: 'Role',
  luoleAdmin_enterpriseUsers_label_status: 'Status',
  luoleAdmin_enterpriseUsers_label_enterprise: 'Enterprise',
  luoleAdmin_enterpriseUsers_label_position: 'Position',
  luoleAdmin_enterpriseUsers_label_employeeId: 'Employee ID',
  luoleAdmin_enterpriseUsers_label_lastLogin: 'Last login',
  luoleAdmin_enterpriseUsers_label_created: 'Created at',
  luoleAdmin_enterpriseUsers_label_updated: 'Updated at',
  luoleAdmin_enterpriseVerify_title: 'Enterprise Verification',
  luoleAdmin_enterpriseVerify_description:
    'Review and approve enterprise qualifications.',
  luoleAdmin_enterpriseVerify_list_failed:
    'Failed to load enterprise verifications.',
  luoleAdmin_enterpriseVerify_review_approved: 'Verification approved.',
  luoleAdmin_enterpriseVerify_review_rejected: 'Verification rejected.',
  luoleAdmin_enterpriseVerify_review_failed:
    'Failed to update verification status.',
  luoleAdmin_enterpriseVerify_status_pending: 'Pending review',
  luoleAdmin_enterpriseVerify_status_pending_description:
    '申請済み、プラットフォームの審査待ち',
  luoleAdmin_enterpriseVerify_status_unverified: '未提出',
  luoleAdmin_enterpriseVerify_status_unverified_description:
    '認証申請はまだ正式に提出されていません',
  luoleAdmin_enterpriseVerify_status_approved: 'Approved',
  luoleAdmin_enterpriseVerify_status_approved_description:
    '認証審査は完了しました',
  luoleAdmin_enterpriseVerify_status_rejected: 'Rejected',
  luoleAdmin_enterpriseVerify_status_rejected_description:
    '審査不承認、再提出待ち',
  luoleAdmin_enterpriseVerify_not_submitted: '未提出',
  luoleAdmin_enterpriseVerify_column_enterprise: 'Enterprise',
  luoleAdmin_enterpriseVerify_column_license: 'Business license',
  luoleAdmin_enterpriseVerify_column_remark: 'Remark',
  luoleAdmin_enterpriseVerify_column_email: 'Email',
  luoleAdmin_enterpriseVerify_column_submittedAt: 'Submitted at',
  luoleAdmin_enterpriseVerify_column_reviewedAt: 'Reviewed at',
  luoleAdmin_enterpriseVerify_column_status: 'Status',
  luoleAdmin_enterpriseVerify_column_actions: 'Actions',
  luoleAdmin_enterpriseVerify_label_contact: 'Contact: {{contact}} | {{phone}}',
  luoleAdmin_enterpriseVerify_action_view: 'View detail',
  luoleAdmin_enterpriseVerify_action_approve: 'Approve',
  luoleAdmin_enterpriseVerify_action_reject: 'Reject',
  luoleAdmin_enterpriseVerify_action_waiting_submit: '企業からの提出待ち',
  luoleAdmin_enterpriseVerify_action_waiting_resubmit: '企業からの再提出待ち',
  luoleAdmin_enterpriseVerify_action_completed: '審査完了',
  luoleAdmin_enterpriseVerify_stat_total: 'Total requests',
  luoleAdmin_enterpriseVerify_stat_pending: 'Pending',
  luoleAdmin_enterpriseVerify_stat_approved: 'Approved',
  luoleAdmin_enterpriseVerify_search_placeholder:
    'Search enterprise name or contact',
  luoleAdmin_enterpriseVerify_filter_all: 'All statuses',
  luoleAdmin_enterpriseVerify_export_button: 'Export list',
  luoleAdmin_enterpriseVerify_detail_title: 'Verification detail',
  luoleAdmin_enterpriseVerify_step_submitted: 'Submitted',
  luoleAdmin_enterpriseVerify_step_submitted_desc:
    'Enterprise submitted verification request',
  luoleAdmin_enterpriseVerify_step_reviewing: 'Reviewing',
  luoleAdmin_enterpriseVerify_step_reviewing_desc:
    'Administrator is reviewing materials',
  luoleAdmin_enterpriseVerify_step_completed: 'Completed',
  luoleAdmin_enterpriseVerify_step_completed_desc:
    'Verification approved or rejected',
  luoleAdmin_enterpriseVerify_modal_title_approve: 'Approve verification',
  luoleAdmin_enterpriseVerify_modal_title_reject: 'Reject verification',
  luoleAdmin_enterpriseVerify_modal_desc_approve:
    'Confirm the enterprise information is correct and approve verification?',
  luoleAdmin_enterpriseVerify_modal_desc_reject:
    'Please provide the rejection reason to help the enterprise complete the information.',
  luoleAdmin_enterpriseVerify_modal_placeholder_reject:
    'Enter rejection reason',
  luoleAdmin_institutionVerify_title: '大学認証審査',
  luoleAdmin_institutionVerify_description:
    '大学の認証申請と資料を審査します。',
  luoleAdmin_institutionVerify_list_failed:
    '大学認証一覧の読み込みに失敗しました。',
  luoleAdmin_institutionVerify_access_denied_title: 'アクセス権限がありません',
  luoleAdmin_institutionVerify_access_denied_description:
    '大学認証審査はプラットフォーム管理者のみ利用できます。',
  luoleAdmin_institutionVerify_back_home: 'ホームに戻る',
  luoleAdmin_institutionVerify_load_error_title:
    '大学認証一覧を読み込めませんでした',
  luoleAdmin_institutionVerify_load_error_description:
    '大学認証データを一時的に取得できません。しばらくしてから再試行してください。',
  luoleAdmin_institutionVerify_reload: '再読み込み',
  luoleAdmin_institutionVerify_status_all: 'すべて',
  luoleAdmin_institutionVerify_status_pending: '審査待ち',
  luoleAdmin_institutionVerify_status_verified: '承認済み',
  luoleAdmin_institutionVerify_status_supplement: '追加資料待ち',
  luoleAdmin_institutionVerify_status_rejected: '却下',
  luoleAdmin_institutionVerify_status_draft: '下書き',
  luoleAdmin_institutionVerify_status_suspended: '停止',
  luoleAdmin_institutionVerify_status_expired: '期限切れ',
  luoleAdmin_institutionVerify_search_placeholder:
    '学校、テナント、申請者を検索',
  luoleAdmin_institutionVerify_column_school: '学校 / テナント',
  luoleAdmin_institutionVerify_column_applicant: '申請者',
  luoleAdmin_institutionVerify_column_materials: '認証資料',
  luoleAdmin_institutionVerify_column_submittedAt: '申請日時',
  luoleAdmin_institutionVerify_column_reviewedAt: '審査日時',
  luoleAdmin_institutionVerify_column_reviewer: '審査担当者',
  luoleAdmin_institutionVerify_column_comment: '審査メモ',
  luoleAdmin_institutionVerify_action_approve: '承認',
  luoleAdmin_institutionVerify_action_supplement: '追加資料を依頼',
  luoleAdmin_institutionVerify_action_reject: '却下',
  luoleAdmin_institutionVerify_modal_approve_title: '認証を承認',
  luoleAdmin_institutionVerify_modal_supplement_title: '追加資料を依頼',
  luoleAdmin_institutionVerify_modal_reject_title: '認証を却下',
  luoleAdmin_institutionVerify_modal_approve_placeholder: '審査メモ（任意）',
  luoleAdmin_institutionVerify_modal_supplement_placeholder:
    '追加が必要な資料や説明を入力',
  luoleAdmin_institutionVerify_modal_reject_placeholder: '却下理由を入力',
  luoleAdmin_institutionVerify_reason_required: '理由を入力してください。',
  luoleAdmin_institutionVerify_review_approve_success:
    '大学認証を承認しました。',
  luoleAdmin_institutionVerify_review_supplement_success:
    '追加資料を依頼しました。',
  luoleAdmin_institutionVerify_review_reject_success:
    '大学認証を却下しました。',
  luoleAdmin_institutionVerify_modal_delete_title: '大学認証を削除',
  luoleAdmin_institutionVerify_modal_delete_content:
    '「{school}」の認証申請と大学アーカイブを削除します。削除後は再申請できます。',
  luoleAdmin_institutionVerify_delete_success: '大学認証を削除しました。',
  luoleAdmin_memberManagement_title: 'Member Management',
  luoleAdmin_memberManagement_description:
    'Maintain platform member records and credentials.',
  luoleAdmin_memberManagement_load_failed: 'Failed to load members.',
  luoleAdmin_memberManagement_update_success: 'Member updated successfully.',
  luoleAdmin_memberManagement_create_success: 'Member created successfully.',
  luoleAdmin_memberManagement_save_failed: 'Failed to save member.',
  luoleAdmin_memberManagement_delete_success: 'Member deleted successfully.',
  luoleAdmin_memberManagement_delete_failed: 'Failed to delete member.',
  luoleAdmin_memberManagement_action_activate: 'Member activated.',
  luoleAdmin_memberManagement_action_deactivate: 'Member deactivated.',
  luoleAdmin_memberManagement_status_failed: 'Failed to update status.',
  luoleAdmin_memberManagement_detail_failed: 'Failed to load member detail.',
  luoleAdmin_memberManagement_stat_total: 'Total members',
  luoleAdmin_memberManagement_stat_active: 'Active',
  luoleAdmin_memberManagement_stat_inactive: 'Inactive',
  luoleAdmin_memberManagement_search_placeholder:
    'Search username, name or email',
  luoleAdmin_memberManagement_filter_all: 'All statuses',
  luoleAdmin_memberManagement_batch_placeholder:
    'Batch operations will be available soon.',
  luoleAdmin_memberManagement_batch_delete: 'Delete ({{count}}) selected',
  luoleAdmin_memberManagement_add_member: 'Add member',
  luoleAdmin_memberManagement_column_member: 'Member',
  luoleAdmin_memberManagement_column_contact: 'Contact',
  luoleAdmin_memberManagement_column_role: 'Role',
  luoleAdmin_memberManagement_column_registeredAt: 'Registered at',
  luoleAdmin_memberManagement_action_view: 'View detail',
  luoleAdmin_memberManagement_action_edit: 'Edit',
  luoleAdmin_memberManagement_action_delete: 'Delete',
  luoleAdmin_memberManagement_delete_confirm: 'Delete this member?',
  luoleAdmin_memberManagement_pagination_total:
    '{start}-{end} of {total} members',
  luoleAdmin_memberManagement_modal_edit: 'Edit member',
  luoleAdmin_memberManagement_modal_create: 'Add member',
  luoleAdmin_memberManagement_form_username: 'Username',
  luoleAdmin_memberManagement_form_username_placeholder: 'Enter username',
  luoleAdmin_memberManagement_form_realName: 'Full name',
  luoleAdmin_memberManagement_form_realName_placeholder: 'Enter real name',
  luoleAdmin_memberManagement_form_email: 'Email',
  luoleAdmin_memberManagement_form_email_placeholder: 'Enter email',
  luoleAdmin_memberManagement_form_email_invalid: 'Enter a valid email address',
  luoleAdmin_memberManagement_form_phone: 'Phone',
  luoleAdmin_memberManagement_form_phone_placeholder: 'Enter phone number',
  luoleAdmin_memberManagement_form_phone_invalid: 'Enter a valid phone number',
  luoleAdmin_memberManagement_form_role: 'Role',
  luoleAdmin_memberManagement_form_role_placeholder: 'Select role',
  luoleAdmin_memberManagement_form_status: 'Status',
  luoleAdmin_memberManagement_form_status_placeholder: 'Select status',
  luoleAdmin_memberManagement_form_required: 'This field is required.',
  luoleAdmin_memberManagement_role_member: 'Member',
  luoleAdmin_memberManagement_role_manager: 'Manager',
  luoleAdmin_memberManagement_role_admin: 'Administrator',
  luoleAdmin_memberManagement_status_active: 'Active',
  luoleAdmin_memberManagement_status_inactive: 'Inactive',
  luoleAdmin_memberManagement_status_suspended: 'Suspended',
  luoleAdmin_memberManagement_detail_title: 'Member detail',
  luoleAdmin_memberManagement_detail_username: 'Username',
  luoleAdmin_memberManagement_detail_displayName: 'Display name',
  luoleAdmin_memberManagement_detail_phone: 'Phone',
  luoleAdmin_memberManagement_detail_email: 'Email',
  luoleAdmin_memberManagement_detail_role: 'Role',
  luoleAdmin_memberManagement_detail_status: 'Status',
  luoleAdmin_memberManagement_detail_employeeId: 'Employee ID',
  luoleAdmin_memberManagement_detail_position: 'Position',
  luoleAdmin_memberManagement_detail_created: 'Created at',
  luoleAdmin_memberManagement_detail_joined: 'Joined at',
  luoleAdmin_memberManagement_detail_bio: 'Bio',
  luoleAdmin_jobManagement_title: 'Job Management',
  luoleAdmin_jobManagement_description:
    'Publish and maintain enterprise job postings.',
  luoleAdmin_jobManagement_load_failed: 'Failed to load job list.',
  luoleAdmin_jobManagement_delete_success: 'Job deleted successfully.',
  luoleAdmin_jobManagement_delete_failed: 'Failed to delete job.',
  luoleAdmin_jobManagement_batch_empty: 'Select at least one job first.',
  luoleAdmin_jobManagement_batch_delete_success: 'Deleted {{count}} jobs.',
  luoleAdmin_jobManagement_action_publish: 'Job published.',
  luoleAdmin_jobManagement_action_close: 'Job closed.',
  luoleAdmin_jobManagement_status_failed: 'Failed to update job status.',
  luoleAdmin_jobManagement_detail_failed: 'Failed to load job detail.',
  luoleAdmin_jobManagement_update_success: 'Job updated successfully.',
  luoleAdmin_jobManagement_create_success: 'Job created successfully.',
  luoleAdmin_jobManagement_save_failed: 'Failed to save job.',
  luoleAdmin_jobManagement_salary_negotiable: 'Negotiable',
  luoleAdmin_jobManagement_column_job: 'Job information',
  luoleAdmin_jobManagement_column_salary: 'Salary',
  luoleAdmin_jobManagement_column_type: 'Type',
  luoleAdmin_jobManagement_column_status: 'Status',
  luoleAdmin_jobManagement_column_metrics: 'Metrics',
  luoleAdmin_jobManagement_column_publishDate: 'Published at',
  luoleAdmin_jobManagement_column_recruiter: 'Responsible HR',
  luoleAdmin_jobManagement_metric_applications: 'Applications',
  luoleAdmin_jobManagement_metric_views: 'Views',
  luoleAdmin_jobManagement_action_view: 'View detail',
  luoleAdmin_jobManagement_action_edit: 'Edit',
  luoleAdmin_jobManagement_action_delete: 'Delete',
  luoleAdmin_jobManagement_delete_confirm: 'Delete this job?',
  luoleAdmin_jobManagement_batch_delete: 'Delete ({{count}}) selected',
  luoleAdmin_jobManagement_add_job: 'Create job',
  luoleAdmin_jobManagement_pagination_total: '{start}-{end} of {total} jobs',
  luoleAdmin_jobManagement_detail_title: 'Job detail',
  luoleAdmin_jobManagement_detail_description: 'Job description',
  luoleAdmin_jobManagement_detail_requirements: 'Requirements',
  luoleAdmin_jobManagement_modal_edit: 'Edit job',
  luoleAdmin_jobManagement_modal_create: 'Create job',
  luoleAdmin_jobManagement_form_title: 'Job title',
  luoleAdmin_jobManagement_form_title_placeholder: 'Enter job title',
  luoleAdmin_jobManagement_form_location: 'Location',
  luoleAdmin_jobManagement_form_location_placeholder: 'Enter job location',
  luoleAdmin_jobManagement_form_type: 'Job type',
  luoleAdmin_jobManagement_form_type_placeholder: 'Select job type',
  luoleAdmin_jobManagement_form_category: 'Job category',
  luoleAdmin_jobManagement_form_category_placeholder: 'Select job category',
  luoleAdmin_jobManagement_form_salary: 'Salary range',
  luoleAdmin_jobManagement_form_salary_min: 'Minimum',
  luoleAdmin_jobManagement_form_salary_max: 'Maximum',
  luoleAdmin_jobManagement_form_headcount: 'Headcount',
  luoleAdmin_jobManagement_form_education: 'Minimum education',
  luoleAdmin_jobManagement_form_education_placeholder:
    'Enter education requirement',
  luoleAdmin_jobManagement_form_experience: 'Experience (years)',
  luoleAdmin_jobManagement_form_experience_placeholder:
    'Enter experience requirement',
  luoleAdmin_jobManagement_form_description: 'Description',
  luoleAdmin_jobManagement_form_description_placeholder: 'Describe the role',
  luoleAdmin_jobManagement_form_requirements: 'Requirements',
  luoleAdmin_jobManagement_form_requirements_placeholder:
    'List key requirements',
  luoleAdmin_jobManagement_form_benefits: 'Benefits',
  luoleAdmin_jobManagement_form_benefits_placeholder:
    'Describe compensation & perks',
  luoleAdmin_jobManagement_form_expireDate: 'Application deadline',
  luoleAdmin_jobManagement_form_expireDate_placeholder: 'YYYY-MM-DD',
  luoleAdmin_jobManagement_form_required: 'This field is required.',
  luoleAdmin_jobManagement_createChoice_title: 'Select Creation Method',
  luoleAdmin_jobManagement_createChoice_fromBlank: 'Create from scratch',
  luoleAdmin_jobManagement_createChoice_fromBlank_desc:
    'Create new position information',
  luoleAdmin_jobManagement_createChoice_fromTemplate:
    'Create based on existing published position',
  luoleAdmin_jobManagement_createChoice_fromTemplate_desc:
    'Select an existing published position as a template for quick creation',
  luoleAdmin_jobManagement_templateList_title:
    'Select published position as template',
  luoleAdmin_jobManagement_templateList_use: 'Use this template',
  luoleAdmin_jobManagement_message_load_published_failed:
    'Failed to load published positions.',
  luoleAdmin_jobManagement_status_active: 'Published',
  luoleAdmin_jobManagement_status_inactive: 'Draft',
  luoleAdmin_jobManagement_status_closed: 'Closed',
  luoleAdmin_jobManagement_status_archived: 'Archived',
  luoleAdmin_jobManagement_status_unknown: 'Unknown',
  luoleAdmin_jobManagement_type_fullTime: 'Full-time',
  luoleAdmin_jobManagement_type_partTime: 'Part-time',
  luoleAdmin_jobManagement_type_contract: 'Contract',
  luoleAdmin_jobManagement_type_internship: 'Internship',
  luoleAdmin_jobManagement_type_other: 'Other',
  luoleAdmin_jobManagement_unknown_company: 'Unknown company',
  luoleAdmin_jobManagement_unknown_location: 'Unknown location',
  luoleAdmin_jobManagement_filter_status_all: 'All statuses',
  luoleAdmin_jobManagement_filter_category_all: 'All categories',
  luoleAdmin_jobManagement_tab_all: 'All',
  luoleAdmin_jobManagement_tab_active: 'Recruiting',
  luoleAdmin_jobManagement_tab_pending: 'Pending',
  luoleAdmin_jobManagement_tab_closed: 'Closed',
  luoleAdmin_jobManagement_tab_draft: 'Draft',
  luoleAdmin_jobManagement_search_placeholder: 'Search job title or company',
  luoleAdmin_jobManagement_stat_total: 'Total jobs',
  luoleAdmin_jobManagement_stat_active: 'Published',
  luoleAdmin_jobManagement_stat_draft: 'Draft',
  luoleAdmin_jobManagement_stat_applications: 'Applications',
  luoleAdmin_jobManagement_detail_responsibilities: 'Responsibilities',
  luoleAdmin_jobPublish_title: 'Publish Job',
  luoleAdmin_jobPublish_description: 'Create and publish a new job posting',
  luoleAdmin_jobPublish_recruitment_type: 'Recruitment Type',
  luoleAdmin_jobPublish_recruitment_type_required:
    'Please select recruitment type',
  luoleAdmin_jobPublish_recruitment_type_social: 'Social Recruitment',
  luoleAdmin_jobPublish_recruitment_type_fresh_graduate: 'Fresh Graduate',
  luoleAdmin_jobPublish_recruitment_type_internship: 'Internship',
  luoleAdmin_jobPublish_recruitment_type_headhunting: 'Headhunting Service',
  luoleAdmin_jobPublish_job_title: 'Job Title',
  luoleAdmin_jobPublish_job_title_required: 'Please enter job title',
  luoleAdmin_jobPublish_job_title_placeholder:
    'Please fill in the job title carefully, it cannot be modified after publishing',
  luoleAdmin_jobPublish_job_category: 'Job Category',
  luoleAdmin_jobPublish_job_category_required: 'Please select job category',
  luoleAdmin_jobPublish_job_category_placeholder:
    'Please enter or select job category',
  luoleAdmin_jobCategorySelector_title: 'Please select job category',
  luoleAdmin_jobCategorySelector_search_placeholder:
    'Please enter job title to search',
  luoleAdmin_jobCategorySelector_feedback: 'Job category feedback',
  luoleAdmin_jobCategorySelector_select_first_level:
    'Please select a category from the left',
  luoleAdmin_jobCategorySelector_no_results: 'No matching results',
  luoleAdmin_jobPublish_job_description: 'Job Description',
  luoleAdmin_jobPublish_job_description_required:
    'Please enter job description',
  luoleAdmin_jobPublish_job_description_placeholder:
    'Responsibilities:\nRequirements:',
  luoleAdmin_jobPublish_ai_write: 'AI Assisted Writing',
  luoleAdmin_jobPublish_ai_write_hint:
    'Not sure how to write a JD? Try AI assisted writing~',
  luoleAdmin_jobPublish_ai_write_coming_soon: 'AI writing feature coming soon',
  luoleAdmin_jobPublish_ai_writing:
    'AI is generating job description, please wait...',
  luoleAdmin_jobPublish_ai_write_success:
    'Job description generated successfully',
  luoleAdmin_jobPublish_ai_write_failed:
    'Failed to generate job description, please try again later',
  luoleAdmin_jobPublish_view_examples: 'See how others write',
  luoleAdmin_jobPublish_view_examples_coming_soon: 'Examples coming soon',
  luoleAdmin_jobPublish_description_warning:
    'Please do not include discriminatory content in the job description',
  luoleAdmin_jobPublish_use_template: 'Use Template/Draft',
  luoleAdmin_jobPublish_job_requirements: 'Job Requirements',
  luoleAdmin_jobPublish_job_requirements_placeholder:
    'Enter job requirements, AI assisted writing supported',
  luoleAdmin_jobPublish_ai_write_requirements_hint:
    'AI will automatically generate job requirements based on job information',
  luoleAdmin_jobPublish_ai_writing_requirements:
    'AI is generating job requirements, please wait...',
  luoleAdmin_jobPublish_ai_write_requirements_success:
    'Job requirements generated successfully',
  luoleAdmin_jobPublish_ai_write_requirements_failed:
    'Failed to generate job requirements, please try again later',
  luoleAdmin_jobPublish_work_experience: 'Work Experience',
  luoleAdmin_jobPublish_work_experience_required:
    'Please select work experience',
  luoleAdmin_jobPublish_work_experience_placeholder:
    'Work experience requirements',
  luoleAdmin_jobPublish_experience_no_limit: 'No limit',
  luoleAdmin_jobPublish_experience_1_year: '1 year',
  luoleAdmin_jobPublish_experience_2_years: '2 years',
  luoleAdmin_jobPublish_experience_3_years: '3 years',
  luoleAdmin_jobPublish_experience_5_years: '5 years',
  luoleAdmin_jobPublish_experience_10_years: '10+ years',
  luoleAdmin_jobPublish_allow_students: 'Allow students to apply',
  luoleAdmin_jobPublish_education_level: 'Education Requirements',
  luoleAdmin_jobPublish_education_level_required:
    'Please select education level',
  luoleAdmin_jobPublish_education_level_placeholder:
    'Minimum education requirements',
  luoleAdmin_jobPublish_education_no_limit: 'No limit',
  luoleAdmin_jobPublish_education_college: 'College',
  luoleAdmin_jobPublish_education_bachelor: 'Bachelor',
  luoleAdmin_jobPublish_education_master: 'Master',
  luoleAdmin_jobPublish_education_doctor: 'Doctor',
  luoleAdmin_jobPublish_unified_recruitment: 'Unified Recruitment',
  luoleAdmin_jobPublish_salary_range: 'Salary Range',
  luoleAdmin_jobPublish_salary_range_required: 'Please select salary range',
  luoleAdmin_jobPublish_salary_max_less_than_min:
    'Maximum salary must be greater than minimum salary',
  luoleAdmin_jobPublish_salary_min: 'Minimum monthly salary',
  luoleAdmin_jobPublish_salary_max: 'Maximum monthly salary',
  luoleAdmin_jobPublish_salary_months_12: '12 months',
  luoleAdmin_jobPublish_salary_months_13: '13 months',
  luoleAdmin_jobPublish_salary_months_14: '14 months',
  luoleAdmin_jobPublish_salary_negotiable: 'Negotiable',
  luoleAdmin_jobPublish_benefits: 'Job Benefits',
  luoleAdmin_jobPublish_add_benefit: 'Add Benefits',
  luoleAdmin_jobPublish_add_benefit_prompt: 'Enter benefit name',
  luoleAdmin_jobPublish_language_requirements: 'Language Requirements',
  luoleAdmin_jobPublish_language_mandarin: 'Mandarin',
  luoleAdmin_jobPublish_language_english: 'English',
  luoleAdmin_jobPublish_language_cantonese: 'Cantonese',
  luoleAdmin_jobPublish_language_french: 'French',
  luoleAdmin_jobPublish_language_japanese: 'Japanese',
  luoleAdmin_jobPublish_language_other: 'Other',
  luoleAdmin_jobPublish_overseas_experience: 'Overseas Experience',
  luoleAdmin_jobPublish_overseas_work_experience: 'Overseas work experience',
  luoleAdmin_jobPublish_overseas_education_background:
    'Overseas education background',
  luoleAdmin_jobPublish_work_location: 'Work Location',
  luoleAdmin_jobPublish_work_location_required: 'Please select work location',
  luoleAdmin_jobPublish_work_location_placeholder:
    'Please select the city carefully, it cannot be modified after publishing',
  luoleAdmin_jobPublish_map_select: 'Select on Map',
  luoleAdmin_jobPublish_map_select_location: 'Select Location',
  luoleAdmin_jobPublish_map_select_prompt:
    'Please select a location on the map, then copy the address to the input box',
  luoleAdmin_jobPublish_map_select_failed:
    'Failed to open map. Please try again or enter the address manually',
  luoleAdmin_mapLocationPicker_title: 'Select Location on Map',
  luoleAdmin_mapLocationPicker_search_placeholder:
    'Search for location or address',
  luoleAdmin_mapLocationPicker_loading: 'Loading map...',
  luoleAdmin_mapLocationPicker_selected_address: 'Selected Address',
  luoleAdmin_mapLocationPicker_tip_click:
    'Click on the map to select a location',
  luoleAdmin_mapLocationPicker_tip_drag:
    'You can drag the marker to adjust the position',
  luoleAdmin_mapLocationPicker_geocode_failed:
    'Failed to get address from coordinates',
  luoleAdmin_mapLocationPicker_search_not_found:
    'Location not found, please try another keyword',
  luoleAdmin_mapLocationPicker_select_first:
    'Please select a location on the map first',
  luoleAdmin_mapLocationPicker_select_success: 'Location selected successfully',
  luoleAdmin_mapLocationPicker_load_failed:
    'Failed to load map script, please check your network connection',
  luoleAdmin_mapLocationPicker_init_failed:
    'Failed to initialize map, please try again',
  luoleAdmin_mapLocationPicker_config_invalid:
    'AMap API Key is not configured or invalid. Please check the configuration file',
  luoleAdmin_mapLocationPicker_api_key_invalid:
    'AMap API Key is invalid. Please check the configuration file src/web/config/amap.ts',
  luoleAdmin_jobPublish_industry_requirements: 'Industry Requirements',
  luoleAdmin_jobPublish_industry_requirements_required:
    'Please select industry',
  luoleAdmin_jobPublish_all_industries: 'All Industries',
  luoleAdmin_jobPublish_add_industry: 'Add Industry',
  luoleAdmin_jobPublish_add_industry_prompt: 'Enter industry name',
  luoleAdmin_jobPublish_industry_already_exists: 'This industry already exists',
  luoleAdmin_jobPublish_submit: 'Publish',
  luoleAdmin_jobPublish_create_success: 'Job published successfully',
  luoleAdmin_jobPublish_create_failed: 'Failed to publish job',
  luoleAdmin_jobPublish_load_template_failed: 'Failed to load template',
  luoleAdmin_jobPublish_title_edit: 'Edit Job',
  luoleAdmin_jobPublish_description_edit:
    'Edit job information, click submit to save changes',
  luoleAdmin_jobPublish_update_success: 'Job updated successfully',
  luoleAdmin_jobPublish_update_failed: 'Failed to update job',
  luoleAdmin_jobPublish_load_job_failed: 'Failed to load job details',
  luoleAdmin_jobPublish_recruiter: 'Responsible HR',
  luoleAdmin_jobPublish_recruiter_required: 'Please select responsible HR',
  luoleAdmin_jobPublish_recruiter_placeholder: 'Please select responsible HR',
  luoleAdmin_jobPublish_load_hrs_failed: 'Failed to load HR list',
  luoleAdmin_jobPublish_no_hr_available:
    'No HR available for this organization',
  luoleAdmin_jobPublish_job_fair: 'Associated Job Fair',
  luoleAdmin_jobPublish_job_fair_placeholder:
    'Select associated job fair (optional)',
  luoleAdmin_common_back: 'Back',
  luoleAdmin_jobPending_title: 'Pending Jobs',
  luoleAdmin_jobPending_description: 'Review jobs waiting for approval.',
  luoleAdmin_resumeManagement_title: 'Resume Management',
  luoleAdmin_resumeManagement_description:
    'Manage all candidate resume information in the platform.',
  luoleAdmin_resumeManagement_search_placeholder:
    'Search candidate or position',
  luoleAdmin_resumeManagement_status_placeholder: 'Filter by status',
  luoleAdmin_resumeManagement_status_all: 'All statuses',
  luoleAdmin_resumeManagement_status_active: 'Active',
  luoleAdmin_resumeManagement_status_inactive: 'Inactive',
  luoleAdmin_resumeManagement_status_archived: 'Archived',
  luoleAdmin_resumeManagement_experience_placeholder: 'Filter by experience',
  luoleAdmin_resumeManagement_experience_all: 'All experience',
  luoleAdmin_resumeManagement_experience_junior: '0-3 years',
  luoleAdmin_resumeManagement_experience_mid: '3-7 years',
  luoleAdmin_resumeManagement_experience_senior: '7+ years',
  luoleAdmin_resumeManagement_stat_total: 'Total resumes',
  luoleAdmin_resumeManagement_stat_active: 'Active resumes',
  luoleAdmin_resumeManagement_stat_avgCompleteness: 'Average completeness',
  luoleAdmin_resumeManagement_stat_viewsDownloads: 'Total views/downloads',
  luoleAdmin_resumeManagement_action_export: 'Export list',
  luoleAdmin_resumeManagement_action_batch: 'Batch operations',
  luoleAdmin_resumeManagement_table_candidate: 'Candidate information',
  luoleAdmin_resumeManagement_table_title: 'Resume title',
  luoleAdmin_resumeManagement_table_experience: 'Experience/Education',
  luoleAdmin_resumeManagement_table_skills: 'Skill tags',
  luoleAdmin_resumeManagement_table_completeness: 'Completeness',
  luoleAdmin_resumeManagement_table_rating: 'Score',
  luoleAdmin_resumeManagement_table_status: 'Status',
  luoleAdmin_resumeManagement_table_stats: 'Data statistics',
  luoleAdmin_resumeManagement_table_lastUpdate: 'Last update',
  luoleAdmin_resumeManagement_table_actions: 'Actions',
  luoleAdmin_resumeManagement_action_view: 'View detail',
  luoleAdmin_resumeManagement_action_download: 'Download resume',
  luoleAdmin_resumeManagement_detail_title: 'Resume detail',
  luoleAdmin_resumeManagement_detail_candidate: 'Candidate',
  luoleAdmin_resumeManagement_detail_position: 'Desired position',
  luoleAdmin_resumeManagement_detail_phone: 'Phone',
  luoleAdmin_resumeManagement_detail_email: 'Email',
  luoleAdmin_resumeManagement_detail_location: 'Desired city',
  luoleAdmin_resumeManagement_detail_salary: 'Desired salary',
  luoleAdmin_resumeManagement_detail_skills: 'Skills',
  luoleAdmin_resumeManagement_detail_selfEvaluation: 'Self evaluation',
  luoleAdmin_resumeManagement_message_load_failed:
    'Failed to load resume list.',
  luoleAdmin_resumeManagement_message_load_detail_failed:
    'Failed to load resume detail.',
  luoleAdmin_resumeManagement_message_no_attachment:
    'This resume has no attachment.',
  luoleAdmin_resumeManagement_unknown_candidate: 'Unnamed candidate',
  luoleAdmin_resumeManagement_unknown_title: 'No position specified',
  luoleAdmin_resumeManagement_unknown_status: 'Unknown',
  luoleAdmin_resumeLibrary_title: 'Resume Library',
  luoleAdmin_resumeLibrary_all_favorites: 'All Resumes',
  luoleAdmin_resumeLibrary_manage: 'Manage',
  luoleAdmin_resumeLibrary_load_failed: 'Failed to load resume list.',
  luoleAdmin_resumeLibrary_load_groups_failed: 'Failed to load groups.',
  luoleAdmin_resumeLibrary_empty: 'No data',
  luoleAdmin_resumeLibrary_select_first: 'Please select resumes first.',
  luoleAdmin_resumeLibrary_batch_unfavorite: 'Cancel Favorite',
  luoleAdmin_resumeLibrary_batch_remove_from_group: 'Remove from Group',
  luoleAdmin_resumeLibrary_batch_view: 'Batch Browse Resumes',
  luoleAdmin_resumeLibrary_forward: 'Forward to Colleagues',
  luoleAdmin_resumeLibrary_view_resume: 'View resume: {{name}}',
  luoleAdmin_resumeLibrary_search_resume_id: 'Resume ID',
  luoleAdmin_resumeLibrary_search_name: 'Name',
  luoleAdmin_resumeLibrary_search_position: 'Current Position',
  luoleAdmin_resumeLibrary_search_company: 'Current Company',
  luoleAdmin_resumeLibrary_column_name: 'Name',
  luoleAdmin_resumeLibrary_column_gender: 'Gender',
  luoleAdmin_resumeLibrary_column_age: 'Age',
  luoleAdmin_resumeLibrary_column_education: 'Education',
  luoleAdmin_resumeLibrary_column_position: 'Current Position',
  luoleAdmin_resumeLibrary_column_company: 'Current Company',
  luoleAdmin_resumeLibrary_column_collected_time: 'Added Time',
  luoleAdmin_resumeLibrary_pagination: 'Total {total} resumes, {{pages}} pages',
  luoleAdmin_applicationManagement_title: 'Application Management',
  luoleAdmin_applicationManagement_description:
    'Track recruitment applications and workflow.',
  luoleAdmin_applicationManagement_search_placeholder:
    'Search candidate or job',
  luoleAdmin_applicationManagement_status_placeholder: 'Filter by status',
  luoleAdmin_applicationManagement_status_all: 'All statuses',
  luoleAdmin_applicationManagement_status_applied: 'Applied',
  luoleAdmin_applicationManagement_status_screening: 'Screening',
  luoleAdmin_applicationManagement_status_interviewing: 'Interviewing',
  luoleAdmin_applicationManagement_status_offered: 'Offered',
  luoleAdmin_applicationManagement_status_accepted: 'Accepted',
  luoleAdmin_applicationManagement_status_rejected: 'Rejected',
  luoleAdmin_applicationManagement_status_withdrawn: 'Withdrawn',
  luoleAdmin_applicationManagement_card_total: 'Total applications',
  luoleAdmin_applicationManagement_card_total_desc:
    'All submissions recorded in the system.',
  luoleAdmin_applicationManagement_card_screening: 'Screening',
  luoleAdmin_applicationManagement_card_screening_desc:
    'Applications currently under screening.',
  luoleAdmin_applicationManagement_card_interviewing: 'Interviewing',
  luoleAdmin_applicationManagement_card_interviewing_desc:
    'Candidates scheduled for interviews.',
  luoleAdmin_applicationManagement_card_accepted: 'Accepted',
  luoleAdmin_applicationManagement_card_accepted_desc:
    'Hires confirmed by enterprises.',
  luoleAdmin_applicationManagement_action_batch: 'Batch actions',
  luoleAdmin_applicationManagement_table_candidate: 'Candidate',
  luoleAdmin_applicationManagement_table_job: 'Job',
  luoleAdmin_applicationManagement_table_applyTime: 'Applied at',
  luoleAdmin_applicationManagement_table_status: 'Status',
  luoleAdmin_applicationManagement_table_notes: 'Notes',
  luoleAdmin_applicationManagement_table_notes_empty: 'No notes',
  luoleAdmin_applicationManagement_table_lastUpdate: 'Last update',
  luoleAdmin_applicationManagement_table_actions: 'Actions',
  luoleAdmin_applicationManagement_action_view: 'View detail',
  luoleAdmin_applicationManagement_action_screening: 'Move to screening',
  luoleAdmin_applicationManagement_action_interviewing: 'Schedule interview',
  luoleAdmin_applicationManagement_action_offered: 'Send offer',
  luoleAdmin_applicationManagement_action_rejected: 'Reject application',
  luoleAdmin_applicationManagement_action_accepted: 'Mark as accepted',
  luoleAdmin_applicationManagement_message_load_failed:
    'Failed to load applications.',
  luoleAdmin_applicationManagement_message_updating: 'Updating status...',
  luoleAdmin_applicationManagement_message_update_success: 'Status updated.',
  luoleAdmin_applicationManagement_message_update_failed:
    'Failed to update status.',
  luoleAdmin_applicationManagement_message_resume_failed:
    'Failed to load resume detail.',
  luoleAdmin_applicationManagement_pagination_total:
    '{start}-{end} of {total} records',
  luoleAdmin_applicationManagement_detail_title: 'Application detail',
  luoleAdmin_applicationManagement_detail_candidate: 'Candidate',
  luoleAdmin_applicationManagement_detail_job: 'Job',
  luoleAdmin_applicationManagement_detail_status: 'Current status',
  luoleAdmin_applicationManagement_detail_timeline: 'Timeline',
  luoleAdmin_applicationManagement_detail_submitted: 'Submitted',
  luoleAdmin_applicationManagement_detail_updated: 'Updated',
  luoleAdmin_applicationManagement_detail_notes: 'Notes',
  luoleAdmin_applicationManagement_detail_notes_empty: 'No notes available.',
  luoleAdmin_applicationManagement_detail_steps: 'Status progress',
  luoleAdmin_applicationManagement_detail_resume: 'Resume overview',
  luoleAdmin_applicationManagement_detail_resume_empty:
    'Resume detail is unavailable.',
  luoleAdmin_applicationManagement_detail_empty:
    'Select an application to view detail.',
  luoleAdmin_applicationManagement_resume_title: 'Target role',
  luoleAdmin_applicationManagement_resume_experience: 'Experience',
  luoleAdmin_applicationManagement_resume_skills: 'Key skills',
  luoleAdmin_applicationManagement_table_screening_score: 'Screening Score',
  luoleAdmin_applicationManagement_table_cover_letter: 'Cover Letter',
  luoleAdmin_applicationManagement_table_resume: 'Resume',
  luoleAdmin_applicationManagement_table_updated_at: 'Updated At',
  luoleAdmin_applicationManagement_action_create: 'Create Application',
  luoleAdmin_applicationManagement_action_edit: 'Edit',
  luoleAdmin_applicationManagement_action_delete: 'Delete',
  luoleAdmin_applicationManagement_action_pass_screening: 'Pass Screening',
  luoleAdmin_applicationManagement_action_schedule_interview:
    'Schedule Interview',
  luoleAdmin_applicationManagement_action_send_offer: 'Send Offer',
  luoleAdmin_applicationManagement_action_reject: 'Reject',
  luoleAdmin_applicationManagement_batch_update_status: 'Batch Update Status',
  luoleAdmin_applicationManagement_company_not_set: 'Company Not Set',
  luoleAdmin_applicationManagement_resume_view: 'View Resume',
  luoleAdmin_applicationManagement_resume_view_coming_soon:
    'Resume view feature coming soon',
  luoleAdmin_applicationManagement_detail_coming_soon:
    'Detail view feature coming soon',
  luoleAdmin_applicationManagement_edit_coming_soon: 'Edit feature coming soon',
  luoleAdmin_applicationManagement_create_coming_soon:
    'Create feature coming soon',
  luoleAdmin_applicationManagement_confirm_delete: 'Confirm Delete',
  luoleAdmin_applicationManagement_confirm_delete_description:
    'Are you sure you want to delete this application record? This action cannot be undone.',
  luoleAdmin_applicationManagement_message_delete_success: 'Delete successful',
  luoleAdmin_applicationManagement_message_delete_failed: 'Delete failed',
  luoleAdmin_applicationManagement_message_select_first:
    'Please select records first',
  luoleAdmin_applicationManagement_message_batch_update_success:
    'Batch update successful',
  luoleAdmin_applicationManagement_message_batch_update_failed:
    'Batch update failed',
  luoleAdmin_applicationManagement_pagination_page: 'Page',
  luoleAdmin_applicationManagement_pagination_of: 'of',
  luoleAdmin_applicationManagement_pagination_items: 'items',
  luoleAdmin_jobFairManagement_title: 'Job Fair Management',
  luoleAdmin_jobFairManagement_description:
    'Configure and monitor job fair events.',
  luoleAdmin_menu_jobFairManagement: 'Job Fair Management',
  luoleAdmin_jobFair_search_placeholder: 'Search by name or description',
  luoleAdmin_jobFair_status_placeholder: 'Filter by status',
  luoleAdmin_jobFair_status_all: 'All statuses',
  luoleAdmin_jobFair_status_draft: 'Draft',
  luoleAdmin_jobFair_status_upcoming: 'Upcoming',
  luoleAdmin_jobFair_status_ongoing: 'Ongoing',
  luoleAdmin_jobFair_status_completed: 'Completed',
  luoleAdmin_jobFair_status_cancelled: 'Cancelled',
  luoleAdmin_jobFair_add: 'Create job fair',
  luoleAdmin_jobFair_batch_delete: 'Delete ({{count}}) selected',
  luoleAdmin_jobFair_load_failed: 'Failed to load job fair list.',
  luoleAdmin_jobFair_action_view: 'View detail',
  luoleAdmin_jobFair_action_edit: 'Edit',
  luoleAdmin_jobFair_action_delete: 'Delete',
  luoleAdmin_jobFair_action_copy: 'Copy',
  luoleAdmin_jobFair_delete_confirm:
    'Are you sure you want to delete this job fair?',
  luoleAdmin_jobFair_delete_success: 'Deleted successfully',
  luoleAdmin_jobFair_delete_failed: 'Delete failed',
  luoleAdmin_jobFair_update_success: 'Updated successfully',
  luoleAdmin_jobFair_create_success: 'Created successfully',
  luoleAdmin_jobFair_save_failed: 'Save failed',
  luoleAdmin_jobFair_save_draft: 'Save as Draft',
  luoleAdmin_jobFair_save_draft_success: 'Draft saved successfully',
  luoleAdmin_jobFair_publish: 'Publish',
  luoleAdmin_jobFair_column_name: 'Job Fair Name',
  luoleAdmin_jobFair_column_time: 'Time',
  luoleAdmin_jobFair_column_location: 'Location',
  luoleAdmin_jobFair_column_status: 'Status',
  luoleAdmin_jobFair_column_enterprises: 'Enterprises',
  luoleAdmin_jobFair_column_talents: 'Talents',
  luoleAdmin_jobFair_column_created: 'Created at',
  luoleAdmin_jobFair_column_cover: 'Cover',
  luoleAdmin_jobFair_view_table: 'Table',
  luoleAdmin_jobFair_view_card: 'Card',
  luoleAdmin_jobFair_no_cover: 'No cover',
  luoleAdmin_jobFair_pagination_total: '{start}-{end} of {total} records',
  luoleAdmin_jobFair_modal_create: 'Create job fair',
  luoleAdmin_jobFair_modal_edit: 'Edit job fair',
  luoleAdmin_jobFair_form_page_description_create:
    'Fill in basic information, time & location, and organizer details.',
  luoleAdmin_jobFair_form_page_description_edit:
    'Update job fair information and settings.',
  luoleAdmin_jobFair_form_required: 'This field is required.',
  luoleAdmin_jobFair_form_name: 'Job Fair Name',
  luoleAdmin_jobFair_form_name_placeholder: 'Enter job fair name',
  luoleAdmin_jobFair_form_theme: 'Theme',
  luoleAdmin_jobFair_form_theme_placeholder:
    'Enter theme (e.g., IT, Finance, Healthcare)',
  luoleAdmin_jobFair_form_description: 'Description',
  luoleAdmin_jobFair_form_description_placeholder: 'Enter description',
  luoleAdmin_jobFair_form_startDate: 'Start Date',
  luoleAdmin_jobFair_form_endDate: 'End Date',
  luoleAdmin_jobFair_form_startTime: 'Start Time',
  luoleAdmin_jobFair_form_endTime: 'End Time',
  luoleAdmin_jobFair_form_location: 'Location',
  luoleAdmin_jobFair_form_location_placeholder: 'Enter location',
  luoleAdmin_jobFair_form_maxParticipants: 'Max Participants',
  luoleAdmin_jobFair_form_maxParticipants_placeholder: 'Enter max participants',
  luoleAdmin_jobFair_form_maxEnterprises: 'Max Enterprises',
  luoleAdmin_jobFair_form_maxEnterprises_placeholder: 'Enter max enterprises',
  luoleAdmin_jobFair_form_maxJobs: 'Max Jobs',
  luoleAdmin_jobFair_form_maxJobs_placeholder: 'Enter max jobs',
  luoleAdmin_jobFair_form_organizer: 'Organizer',
  luoleAdmin_jobFair_form_organizer_placeholder: 'Enter organizer',
  luoleAdmin_jobFair_form_contact: 'Contact Person',
  luoleAdmin_jobFair_form_contact_placeholder: 'Enter contact person',
  luoleAdmin_jobFair_form_phone: 'Phone',
  luoleAdmin_jobFair_form_phone_placeholder: 'Enter phone number',
  luoleAdmin_jobFair_form_email: 'Email',
  luoleAdmin_jobFair_form_email_placeholder: 'Enter email address',
  luoleAdmin_jobFair_form_email_invalid: 'Enter a valid email.',
  luoleAdmin_jobFair_form_bannerImage: 'Banner Image',
  luoleAdmin_jobFair_form_coverImage: 'Cover Image',
  luoleAdmin_jobFair_form_coverImage_upload: 'Upload Cover Image',
  luoleAdmin_jobFair_form_coverImage_hint:
    'Recommended size: 1920x600px, max 15MB',
  luoleAdmin_jobFair_form_group_basic: 'Basic Information',
  luoleAdmin_jobFair_form_group_timeLocation: 'Time & Location',
  luoleAdmin_jobFair_form_group_scale: 'Scale Settings',
  luoleAdmin_jobFair_form_group_organizer: 'Organizer Information',
  luoleAdmin_jobFair_form_group_status: 'Status & Cover',
  luoleAdmin_jobFair_form_showOnHomepage: 'Show on Homepage',
  luoleAdmin_jobFair_detail_tab_basic: 'Basic Info',
  luoleAdmin_jobFair_detail_tab_enterprises: 'Enterprises',
  luoleAdmin_jobFair_detail_tab_jobs: 'Jobs',
  luoleAdmin_jobFair_detail_tab_liveStreams: 'Live Streams',
  luoleAdmin_jobFair_detail_tab_statistics: 'Statistics',
  luoleAdmin_jobFair_detail_tab_infoFlow: 'Information Publishing',
  luoleAdmin_jobFair_infoFlow_config_title: 'Information Publishing',
  luoleAdmin_jobFair_infoFlow_add: 'Add Item',
  luoleAdmin_jobFair_infoFlow_edit: 'Edit Item',
  luoleAdmin_jobFair_infoFlow_add_modal: 'Add Information',
  luoleAdmin_jobFair_infoFlow_add_success: 'Added',
  luoleAdmin_jobFair_infoFlow_edit_success: 'Updated',
  luoleAdmin_jobFair_infoFlow_delete_success: 'Deleted',
  luoleAdmin_jobFair_infoFlow_load_failed: 'Failed to load information list',
  luoleAdmin_jobFair_infoFlow_delete_failed: 'Delete failed',
  luoleAdmin_jobFair_infoFlow_type_goodNews: 'Good News',
  luoleAdmin_jobFair_infoFlow_type_announcement: 'Announcement',
  luoleAdmin_jobFair_infoFlow_type_dynamic: 'Dynamic',
  luoleAdmin_jobFair_infoFlow_format_text: 'Text',
  luoleAdmin_jobFair_infoFlow_format_richtext: 'Rich Text',
  luoleAdmin_jobFair_infoFlow_format_image: 'Image',
  luoleAdmin_jobFair_infoFlow_format_link: 'Link',
  luoleAdmin_jobFair_infoFlow_column_sortOrder: 'Order',
  luoleAdmin_jobFair_infoFlow_column_contentType: 'Type',
  luoleAdmin_jobFair_infoFlow_column_format: 'Format',
  luoleAdmin_jobFair_infoFlow_column_title: 'Title',
  luoleAdmin_jobFair_infoFlow_column_content: 'Content',
  luoleAdmin_jobFair_infoFlow_column_status: 'Status',
  luoleAdmin_jobFair_infoFlow_status_draft: 'Draft',
  luoleAdmin_jobFair_infoFlow_status_published: 'Published',
  luoleAdmin_jobFair_infoFlow_carousel_enabled: 'Auto carousel',
  luoleAdmin_jobFair_infoFlow_carousel_interval: 'Interval',
  luoleAdmin_jobFair_infoFlow_carousel_seconds: 's',
  luoleAdmin_jobFair_infoFlow_carousel_mode: 'Mode',
  luoleAdmin_jobFair_infoFlow_linkUrl: 'Link URL',
  luoleAdmin_jobFair_infoFlow_linkUrl_invalid: 'Please enter a valid URL',
  luoleAdmin_jobFair_infoFlow_imageUrl: 'Image URL',
  luoleAdmin_jobFair_infoFlow_title_placeholder: 'Title',
  luoleAdmin_jobFair_infoFlow_content_placeholder: 'Content text',
  luoleAdmin_jobFair_goodNews_title: 'Good News',
  luoleAdmin_jobFair_goodNews_add: 'Add Good News',
  luoleAdmin_jobFair_goodNews_edit: 'Edit Good News',
  luoleAdmin_jobFair_goodNews_add_modal: 'Add Good News',
  luoleAdmin_jobFair_goodNews_add_success: 'Added',
  luoleAdmin_jobFair_goodNews_edit_success: 'Updated',
  luoleAdmin_jobFair_goodNews_delete_success: 'Deleted',
  luoleAdmin_jobFair_goodNews_column_title: 'Title',
  luoleAdmin_jobFair_goodNews_column_source: 'Source',
  luoleAdmin_jobFair_goodNews_column_audit: 'Audit',
  luoleAdmin_jobFair_goodNews_column_verified: 'Verified',
  luoleAdmin_jobFair_goodNews_column_fakeWarning: 'Fake warning',
  luoleAdmin_jobFair_goodNews_source_manual: 'Manual',
  luoleAdmin_jobFair_goodNews_source_auto: 'Auto',
  luoleAdmin_jobFair_goodNews_audit_pending: 'Pending',
  luoleAdmin_jobFair_goodNews_audit_approved_label: 'Approved',
  luoleAdmin_jobFair_goodNews_audit_rejected_label: 'Rejected',
  luoleAdmin_jobFair_goodNews_audit_approve: 'Approve',
  luoleAdmin_jobFair_goodNews_audit_reject: 'Reject',
  luoleAdmin_jobFair_goodNews_audit_approved: 'Approved',
  luoleAdmin_jobFair_goodNews_audit_rejected: 'Rejected',
  luoleAdmin_jobFair_goodNews_verified: 'Verified',
  luoleAdmin_jobFair_goodNews_not_verified: 'Not verified',
  luoleAdmin_jobFair_goodNews_fake_warning: 'Allow fake data',
  luoleAdmin_jobFair_goodNews_fake_warning_hint:
    'When enabled, the item will be marked as "data may be fabricated" for display.',
  luoleAdmin_jobFair_goodNews_data_notice:
    'Ensure data authenticity. You can mark items as "data may be fabricated" for transparency.',
  luoleAdmin_jobFair_goodNews_title_placeholder:
    'e.g. XX company successfully recruited 10 talents',
  luoleAdmin_jobFair_goodNews_content_placeholder: 'Good news content',
  luoleAdmin_messageManagement_title: 'Message Management',
  luoleAdmin_messageManagement_description:
    'Handle feedback and inquiries from enterprises and talents.',
  luoleAdmin_dictionaryManagement_title: '職種カテゴリ',
  luoleAdmin_dictionaryManagement_description:
    '職種分類の階層を管理し、フロントエンド表示と一致させます。',
  luoleAdmin_dictionaryManagement_stat_total: '総カテゴリ数',
  luoleAdmin_dictionaryManagement_stat_active: '有効',
  luoleAdmin_dictionaryManagement_stat_inactive: '無効',
  luoleAdmin_dictionaryManagement_stat_level1: '1級カテゴリ',
  luoleAdmin_dictionaryManagement_tree_title: '職種カテゴリツリー',
  luoleAdmin_dictionaryManagement_search_placeholder:
    'カテゴリ名またはコードで検索',
  luoleAdmin_dictionaryManagement_status_all: 'すべての状態',
  luoleAdmin_dictionaryManagement_status_active: '有効',
  luoleAdmin_dictionaryManagement_status_inactive: '無効',
  luoleAdmin_dictionaryManagement_add: 'カテゴリを追加',
  luoleAdmin_dictionaryManagement_batch_delete: '選択した ({{count}}) を削除',
  luoleAdmin_dictionaryManagement_table_total: '{total} 件中 {start}-{end} 件',
  luoleAdmin_dictionaryManagement_column_name: 'カテゴリ名',
  luoleAdmin_dictionaryManagement_column_value: '値',
  luoleAdmin_dictionaryManagement_column_description: '説明',
  luoleAdmin_dictionaryManagement_column_level: 'レベル',
  luoleAdmin_dictionaryManagement_column_sort: '並び順',
  luoleAdmin_dictionaryManagement_column_status: '状態',
  luoleAdmin_dictionaryManagement_column_createdAt: '作成日時',
  luoleAdmin_dictionaryManagement_column_actions: '操作',
  luoleAdmin_dictionaryManagement_level_label: 'レベル {{level}}',
  luoleAdmin_dictionaryManagement_modal_create: 'カテゴリを追加',
  luoleAdmin_dictionaryManagement_modal_edit: 'カテゴリを編集',
  luoleAdmin_dictionaryManagement_form_name: 'カテゴリ名',
  luoleAdmin_dictionaryManagement_form_name_placeholder: 'カテゴリ名を入力',
  luoleAdmin_dictionaryManagement_form_code: 'コード',
  luoleAdmin_dictionaryManagement_form_code_placeholder: 'コードを入力',
  luoleAdmin_dictionaryManagement_form_value: '値',
  luoleAdmin_dictionaryManagement_form_value_placeholder: '値を入力',
  luoleAdmin_dictionaryManagement_form_description: '説明',
  luoleAdmin_dictionaryManagement_form_description_placeholder: '説明を入力',
  luoleAdmin_dictionaryManagement_form_parent: '親カテゴリ',
  luoleAdmin_dictionaryManagement_form_parent_placeholder:
    '親カテゴリを選択（任意）',
  luoleAdmin_dictionaryManagement_form_sort: '並び順',
  luoleAdmin_dictionaryManagement_form_status: '状態',
  luoleAdmin_dictionaryManagement_form_status_placeholder: '状態を選択',
  luoleAdmin_dictionaryManagement_form_required: 'このフィールドは必須です。',
  luoleAdmin_dictionaryManagement_load_failed:
    '職種カテゴリの読み込みに失敗しました。',
  luoleAdmin_dictionaryManagement_action_failed:
    '操作に失敗しました。もう一度お試しください。',
  luoleAdmin_dictionaryManagement_delete_success: 'カテゴリを削除しました。',
  luoleAdmin_dictionaryManagement_batch_delete_success:
    '{{count}} 件のカテゴリを削除しました。',
  luoleAdmin_dictionaryManagement_enable_success: 'カテゴリを有効にしました。',
  luoleAdmin_dictionaryManagement_disable_success: 'カテゴリを無効にしました。',
  luoleAdmin_dictionaryManagement_create_success: 'カテゴリを作成しました。',
  luoleAdmin_dictionaryManagement_update_success: 'カテゴリを更新しました。',
  luoleAdmin_dictionaryManagement_add_primary: 'Add primary category',
  luoleAdmin_dictionaryManagement_add_under: 'Add child',
  luoleAdmin_dictionaryManagement_add_item: 'Add item',
  luoleAdmin_dictionaryManagement_add_first: 'Add first item',
  luoleAdmin_dictionaryManagement_enable: 'Enable',
  luoleAdmin_dictionaryManagement_disable: 'Disable',
  luoleAdmin_dictionaryManagement_select_category:
    'Select a category on the left',
  luoleAdmin_dictionaryManagement_empty_primary:
    'No primary categories yet. Add one first.',
  luoleAdmin_dictionaryManagement_empty_items: 'No items under this category. ',
  luoleAdmin_dictionaryManagement_move_up: 'Move up',
  luoleAdmin_dictionaryManagement_move_down: 'Move down',
  luoleAdmin_dictionaryManagement_sort_success: 'Sort order updated',
  luoleAdmin_dictionaryManagement_delete_confirm: 'Confirm delete',
  luoleAdmin_dictionaryManagement_delete_confirm_content:
    'Are you sure you want to delete "{{name}}"? This cannot be undone.',
  luoleAdmin_jobCategoriesManagement_title: 'Job Categories Management',
  luoleAdmin_jobCategoriesManagement_description:
    'Manage hierarchical job categories for postings.',
  luoleAdmin_jobCategoriesManagement_stat_total: 'Total categories',
  luoleAdmin_jobCategoriesManagement_stat_active: 'Active',
  luoleAdmin_jobCategoriesManagement_stat_inactive: 'Inactive',
  luoleAdmin_jobCategoriesManagement_stat_jobs: 'Total jobs',
  luoleAdmin_jobCategoriesManagement_tree_title: 'Category tree',
  luoleAdmin_jobCategoriesManagement_search_placeholder: 'Search category name',
  luoleAdmin_jobCategoriesManagement_status_all: 'All statuses',
  luoleAdmin_jobCategoriesManagement_status_active: 'Active',
  luoleAdmin_jobCategoriesManagement_status_inactive: 'Inactive',
  luoleAdmin_jobCategoriesManagement_add: 'Add category',
  luoleAdmin_jobCategoriesManagement_add_root: 'Add root category',
  luoleAdmin_jobCategoriesManagement_batch_delete:
    'Delete ({{count}}) selected',
  luoleAdmin_jobCategoriesManagement_table_total:
    '{start}-{end} of {total} categories',
  luoleAdmin_jobCategoriesManagement_column_name: 'Category',
  luoleAdmin_jobCategoriesManagement_column_level: 'Level',
  luoleAdmin_jobCategoriesManagement_level_root: 'Root',
  luoleAdmin_jobCategoriesManagement_level_child: 'Child',
  luoleAdmin_jobCategoriesManagement_parent_root: 'Root',
  luoleAdmin_jobCategoriesManagement_column_parent: 'Parent',
  luoleAdmin_jobCategoriesManagement_column_sort: 'Sort',
  luoleAdmin_jobCategoriesManagement_column_status: 'Status',
  luoleAdmin_jobCategoriesManagement_column_createdAt: 'Created at',
  luoleAdmin_jobCategoriesManagement_column_actions: 'Actions',
  luoleAdmin_jobCategoriesManagement_modal_create: 'Create category',
  luoleAdmin_jobCategoriesManagement_modal_edit: 'Edit category',
  luoleAdmin_jobCategoriesManagement_form_title: 'Category name',
  luoleAdmin_jobCategoriesManagement_form_title_placeholder:
    'Enter category name',
  luoleAdmin_jobCategoriesManagement_form_parent: 'Parent category',
  luoleAdmin_jobCategoriesManagement_form_parent_placeholder:
    'Select parent category (optional)',
  luoleAdmin_jobCategoriesManagement_form_sort: 'Sort',
  luoleAdmin_jobCategoriesManagement_form_status: 'Status',
  luoleAdmin_jobCategoriesManagement_form_status_placeholder: 'Select status',
  luoleAdmin_jobCategoriesManagement_form_required: 'This field is required.',
  luoleAdmin_jobCategoriesManagement_load_failed:
    'Failed to load job categories.',
  luoleAdmin_jobCategoriesManagement_action_failed:
    'Operation failed, please retry.',
  luoleAdmin_jobCategoriesManagement_delete_confirm: 'Delete category',
  luoleAdmin_jobCategoriesManagement_delete_success: 'Category deleted.',
  luoleAdmin_jobCategoriesManagement_batch_delete_success:
    'Deleted {{count}} categories.',
  luoleAdmin_jobCategoriesManagement_enable_success: 'Category enabled.',
  luoleAdmin_jobCategoriesManagement_disable_success: 'Category disabled.',
  luoleAdmin_jobCategoriesManagement_create_success:
    'Category created successfully.',
  luoleAdmin_jobCategoriesManagement_update_success:
    'Category updated successfully.',
  luoleAdmin_jobCategoriesManagement_enable: 'Enable',
  luoleAdmin_jobCategoriesManagement_disable: 'Disable',
  luoleAdmin_jobCategoriesManagement_add_child: 'Add subcategory',
  luoleAdmin_jobCategoriesManagement_detail_title: 'Category detail - {{name}}',
  luoleAdmin_jobCategoriesManagement_detail_title_default: 'Category detail',
  luoleAdmin_jobCategoriesManagement_detail_load_failed:
    'Failed to load category detail.',
  luoleAdmin_jobCategoriesManagement_detail_select_first:
    'Please select a category first.',
  luoleAdmin_jobCategoriesManagement_detail_invalid_id:
    'Invalid category ID, please refresh and try again.',
  luoleAdmin_jobCategoriesManagement_detail_jobCount: 'Number of positions',
  luoleAdmin_jobCategoriesManagement_detail_childCount:
    'Number of subcategories',
  luoleAdmin_jobCategoriesManagement_detail_status: 'Status',
  luoleAdmin_jobCategoriesManagement_detail_attributes: 'Category attributes',
  luoleAdmin_jobCategoriesManagement_detail_id: 'Category ID',
  luoleAdmin_jobCategoriesManagement_detail_code: 'Category code',
  luoleAdmin_jobCategoriesManagement_detail_level: 'Level',
  luoleAdmin_jobCategoriesManagement_detail_sort: 'Sort order',
  luoleAdmin_jobCategoriesManagement_detail_parent: 'Parent category',
  luoleAdmin_jobCategoriesManagement_detail_createdAt: 'Creation time',
  luoleAdmin_jobCategoriesManagement_detail_updatedAt: 'Update time',
  luoleAdmin_jobCategoriesManagement_detail_children: 'Subcategory list',
  luoleAdmin_jobCategoriesManagement_detail_jobs: 'positions',
  luoleAdmin_jobCategoriesManagement_detail_select_hint:
    'Please select a category from the left to view details.',
  luoleAdmin_jobCategoriesManagement_level_1: 'Level 1',
  luoleAdmin_jobCategoriesManagement_level_2: 'Level 2',
  luoleAdmin_jobCategoriesManagement_level_3: 'Level 3',
  luoleAdmin_jobCategoriesManagement_level_other: 'Level {{level}}',
  luoleAdmin_jobCategoriesManagement_confirm_action: 'Confirm {{action}}',
  luoleAdmin_jobCategoriesManagement_confirm_action_content:
    'Are you sure you want to {{action}} category "{{name}}"?',
  luoleAdmin_jobCategoriesManagement_status_updated:
    'Category {{action}} successfully.',
  luoleAdmin_jobCategoriesManagement_delete_confirm_content:
    'Are you sure you want to delete category "{{name}}"? This operation cannot be undone.',
  luoleAdmin_jobCategoriesManagement_form_parent_hint:
    'Will add subcategory under "{{name}}"',
  luoleAdmin_jobCategoriesManagement_unknown_category: 'Unknown category',
  luoleAdmin_common_loading: 'Loading...',
  luoleAdmin_resumeTemplateManagement_title: 'Resume Template Management',
  luoleAdmin_resumeTemplateManagement_description:
    'Manage resume templates for list display and export.',
  luoleAdmin_resumeTemplateManagement_stat_total: 'Total templates',
  luoleAdmin_resumeTemplateManagement_stat_free: 'Free',
  luoleAdmin_resumeTemplateManagement_stat_featured: 'Featured',
  luoleAdmin_resumeTemplateManagement_search_placeholder:
    'Search template name',
  luoleAdmin_resumeTemplateManagement_category_all: 'All categories',
  luoleAdmin_resumeTemplateManagement_category_free: 'Free',
  luoleAdmin_resumeTemplateManagement_category_featured: 'Featured',
  luoleAdmin_resumeTemplateManagement_isFree_all: 'All',
  luoleAdmin_resumeTemplateManagement_isFree_free: 'Free',
  luoleAdmin_resumeTemplateManagement_isFree_locked: 'Locked',
  luoleAdmin_resumeTemplateManagement_add: 'Add template',
  luoleAdmin_resumeTemplateManagement_column_name: 'Name',
  luoleAdmin_resumeTemplateManagement_column_thumbnail: 'Thumbnail',
  luoleAdmin_resumeTemplateManagement_column_category: 'Category',
  luoleAdmin_resumeTemplateManagement_column_isFree: 'Free',
  luoleAdmin_resumeTemplateManagement_column_sortOrder: 'Sort',
  luoleAdmin_resumeTemplateManagement_column_createdAt: 'Created at',
  luoleAdmin_resumeTemplateManagement_column_actions: 'Actions',
  luoleAdmin_resumeTemplateManagement_modal_create: 'Add template',
  luoleAdmin_resumeTemplateManagement_modal_edit: 'Edit template',
  luoleAdmin_resumeTemplateManagement_form_name: 'Template name',
  luoleAdmin_resumeTemplateManagement_form_name_placeholder:
    'Enter template name',
  luoleAdmin_resumeTemplateManagement_form_thumbnailUrl: 'Thumbnail URL',
  luoleAdmin_resumeTemplateManagement_form_thumbnailUrl_placeholder:
    'Enter thumbnail image URL',
  luoleAdmin_resumeTemplateManagement_form_templateUrl: 'Template URL',
  luoleAdmin_resumeTemplateManagement_form_templateUrl_placeholder:
    'Enter template file or template ID URL',
  luoleAdmin_resumeTemplateManagement_form_tags: 'Tags',
  luoleAdmin_resumeTemplateManagement_form_tags_placeholder:
    'Comma-separated tags',
  luoleAdmin_resumeTemplateManagement_form_isFree: 'Free',
  luoleAdmin_resumeTemplateManagement_form_category: 'Category',
  luoleAdmin_resumeTemplateManagement_form_sortOrder: 'Sort',
  luoleAdmin_resumeTemplateManagement_form_required: 'This field is required.',
  luoleAdmin_resumeTemplateManagement_upload_thumbnail: 'Upload thumbnail',
  luoleAdmin_resumeTemplateManagement_upload_template: 'Upload template file',
  luoleAdmin_resumeTemplateManagement_or_enter_url: 'Or enter URL',
  luoleAdmin_resumeTemplateManagement_uploading: 'Uploading...',
  luoleAdmin_resumeTemplateManagement_load_failed: 'Failed to load templates.',
  luoleAdmin_resumeTemplateManagement_action_failed: 'Operation failed.',
  luoleAdmin_resumeTemplateManagement_delete_confirm: 'Delete this template?',
  luoleAdmin_resumeTemplateManagement_delete_success: 'Template deleted.',
  luoleAdmin_resumeTemplateManagement_batch_delete_success:
    'Deleted {{count}} templates.',
  luoleAdmin_resumeTemplateManagement_create_success: 'Template created.',
  luoleAdmin_resumeTemplateManagement_update_success: 'Template updated.',
  luoleAdmin_talentRecommendation_title: 'Talent Recommendation',
  luoleAdmin_talentRecommendation_description:
    'Recommend matching talents based on published job positions.',
  luoleAdmin_talentRecommendation_select_job: 'Select Job',
  luoleAdmin_talentRecommendation_select_job_placeholder:
    'Please select a job position',
  luoleAdmin_talentRecommendation_select_job_first:
    'Please select a job position first',
  luoleAdmin_talentRecommendation_min_match_score: 'Minimum Match Score',
  luoleAdmin_talentRecommendation_filter_all: 'All',
  luoleAdmin_talentRecommendation_generate: 'Generate Recommendations',
  luoleAdmin_talentRecommendation_load_jobs_failed: 'Failed to load job list',
  luoleAdmin_talentRecommendation_load_failed: 'Failed to load recommendations',
  luoleAdmin_talentRecommendation_generate_success:
    'Recommendations generated successfully',
  luoleAdmin_talentRecommendation_generate_failed:
    'Failed to generate recommendations',
  luoleAdmin_talentRecommendation_detail_failed: 'Failed to load talent detail',
  luoleAdmin_talentRecommendation_empty: 'No recommendations available',
  luoleAdmin_talentRecommendation_column_rank: 'Rank',
  luoleAdmin_talentRecommendation_column_talent: 'Talent',
  luoleAdmin_talentRecommendation_column_matchScore: 'Match Score',
  luoleAdmin_talentRecommendation_column_matchReasons: 'Match Reasons',
  luoleAdmin_talentRecommendation_column_job: 'Job',
  luoleAdmin_talentRecommendation_match_excellent: 'Excellent',
  luoleAdmin_talentRecommendation_match_good: 'Good',
  luoleAdmin_talentRecommendation_match_fair: 'Fair',
  luoleAdmin_talentRecommendation_match_poor: 'Poor',
  luoleAdmin_talentRecommendation_job_title: 'Job Title',
  luoleAdmin_talentRecommendation_job_location: 'Location',
  luoleAdmin_talentRecommendation_job_category: 'Category',
  luoleAdmin_talentRecommendation_job_type: 'Type',
  luoleAdmin_talentRecommendation_stat_total: 'Total Recommendations',
  luoleAdmin_talentRecommendation_stat_avg_match_score: 'Average Match Score',
  luoleAdmin_talentRecommendation_stat_excellent: 'Excellent Matches',
  luoleAdmin_talentRecommendation_stat_good: 'Good Matches',
  luoleAdmin_talentRecommendation_detail_title: 'Talent Detail',
  luoleAdmin_talentRecommendation_detail_name: 'Name',
  luoleAdmin_talentRecommendation_detail_email: 'Email',
  luoleAdmin_talentRecommendation_detail_phone: 'Phone',
  luoleAdmin_talentRecommendation_detail_position: 'Position',
  luoleAdmin_talentRecommendation_detail_status: 'Status',
  luoleAdmin_talentRecommendation_detail_bio: 'Bio',
  luoleAdmin_talentRecommendation_detail_created: 'Created At',
  luoleAdmin_talentRecommendation_pagination_total:
    '{start}-{end} of {total} records',
  luoleAdmin_common_unknown: 'Unknown',
  talents_cancel: 'Cancel',
  talents_action_save: 'Save',
  talents_modal_add_title: 'Create talent',
  talents_modal_edit_title: 'Edit talent',
  talents_import_title: 'Upload resume',
  talents_import_file_label: 'Resume file',
  talents_import_file_hint: 'Click to upload resume',
  talents_import_file_support: 'Supports PDF, DOC, DOCX files up to 10MB',
  talents_import_parse_info: 'Resume parsed and applied to the form',
  talents_import_failed: 'Failed to upload resume',
  talents_save_failed: 'Failed to save talent',
  talents_basic_info: 'Basic information',
  talents_status_active: 'Active',
  talents_status_inactive: 'Inactive',
  talents_status_placed: 'Placed',
  talents_status_blacklisted: 'Blacklisted',
  talents_field_avatar_upload: 'Upload avatar',
  talents_field_avatar_uploading: 'Uploading avatar...',
  talents_field_name: 'Name',
  talents_field_name_required: 'Please enter name',
  talents_field_name_placeholder: 'Enter name',
  talents_field_gender: 'Gender',
  talents_field_gender_male: 'Male',
  talents_field_gender_female: 'Female',
  talents_field_gender_placeholder: 'Select gender',
  talents_field_status: 'Talent status',
  talents_field_status_placeholder: 'Select status',
  talents_field_age: 'Age',
  talents_field_age_placeholder: 'Enter age',
  talents_field_birthdate: 'Birth date',
  talents_field_education: 'Education',
  talents_field_education_placeholder: 'Select education',
  talents_field_phone: 'Phone',
  talents_field_phone_placeholder: 'Enter phone',
  talents_field_email: 'Email',
  talents_field_email_placeholder: 'Enter email',
  talents_field_wechat: 'WeChat',
  talents_field_current_company: 'Current company',
  talents_field_current_company_placeholder: 'Enter current company',
  talents_field_current_position: 'Current position',
  talents_field_current_position_placeholder: 'Enter current position',
  talents_field_current_salary: 'Current salary (per month)',
  talents_field_current_salary_placeholder: 'Enter current salary',
  talents_field_work_experience: 'Work experience (years)',
  talents_field_work_experience_placeholder: 'Enter work experience',
  talents_field_source: 'Source',
  talents_field_location: 'Current city',
  talents_field_location_placeholder: 'Enter current city',
  talents_field_tags: 'Tags',
  talents_field_tags_placeholder: 'Add tags',
  talents_field_notes: 'Notes',
  talents_field_notes_placeholder: 'Enter notes',
  talents_work_history: 'Work history',
  talents_project_experience: 'Project experience',
  talents_education_experience: 'Education experience',
  talents_field_company: 'Company',
  talents_field_department: 'Department',
  talents_field_position: 'Position',
  talents_field_start_date: 'Start date',
  talents_field_end_date: 'End date',
  talents_field_is_current: 'Currently working',
  talents_field_description: 'Description',
  talents_add_work_history: 'Add work history',
  talents_add_project: 'Add project',
  talents_add_education: 'Add education',
  talents_remove: 'Remove',
  luoleAdmin_talentPool_search_placeholder:
    'Search positions/companies/industries (separate Chinese with spaces, English with commas)',
  luoleAdmin_talentPool_search_include_all: 'Include all keywords',
  luoleAdmin_talentPool_search_include_any: 'Include any keywords',
  luoleAdmin_talentPool_filter_position: 'Position',
  luoleAdmin_talentPool_filter_position_placeholder: 'Search position',
  luoleAdmin_talentPool_filter_position_all: 'All positions',
  luoleAdmin_talentPool_filter_position_custom: 'Custom position',
  luoleAdmin_talentPool_filter_company: 'Company',
  luoleAdmin_talentPool_filter_company_placeholder: 'Search company',
  luoleAdmin_talentPool_filter_company_all: 'All companies',
  luoleAdmin_talentPool_filter_company_custom: 'Custom company',
  luoleAdmin_talentPool_filter_apply: 'Apply filters',
  luoleAdmin_talentPool_less_conditions: 'Less conditions',
  luoleAdmin_talentPool_filter_currentCity: 'Current city',
  luoleAdmin_talentPool_filter_currentCity_no_limit: 'No limit',
  luoleAdmin_talentPool_filter_currentCity_other: 'Other',
  luoleAdmin_talentPool_filter_expectedCity: 'Expected city',
  luoleAdmin_talentPool_filter_expectedCity_no_limit: 'No limit',
  luoleAdmin_talentPool_filter_expectedCity_beijing: 'Beijing',
  luoleAdmin_talentPool_filter_expectedCity_other: 'Other',
  luoleAdmin_talentPool_filter_experience: 'Experience',
  luoleAdmin_talentPool_filter_experience_no_limit: 'No limit',
  luoleAdmin_talentPool_filter_experience_student: 'Student/Fresh graduate',
  luoleAdmin_talentPool_filter_experience_1_3: '1-3 years',
  luoleAdmin_talentPool_filter_experience_3_5: '3-5 years',
  luoleAdmin_talentPool_filter_experience_5_10: '5-10 years',
  luoleAdmin_talentPool_filter_experience_custom: 'Custom',
  luoleAdmin_talentPool_filter_education: 'Education',
  luoleAdmin_talentPool_filter_education_no_limit: 'No limit',
  luoleAdmin_talentPool_filter_education_bachelor: 'Bachelor',
  luoleAdmin_talentPool_filter_education_master: 'Master',
  luoleAdmin_talentPool_filter_education_phd: 'PhD/Postdoc',
  luoleAdmin_talentPool_filter_education_college: 'Associate',
  luoleAdmin_talentPool_filter_education_vocational: 'Vocational',
  luoleAdmin_talentPool_filter_education_high_school: 'High school or below',
  luoleAdmin_talentPool_filter_other: 'Other filters',
  luoleAdmin_talentPool_filter_activeStatus: 'Active status',
  luoleAdmin_talentPool_filter_jobStatus: 'Job seeking status',
  luoleAdmin_talentPool_filter_graduationSchool: 'Graduation school',
  luoleAdmin_talentPool_filter_graduationSchool_placeholder:
    'Enter graduation school',
  luoleAdmin_talentPool_filter_major: 'Major',
  luoleAdmin_talentPool_filter_major_placeholder: 'Enter major',
  luoleAdmin_talentPool_reset_conditions: 'Reset conditions',
  luoleAdmin_talentPool_more_conditions: 'More conditions',
  luoleAdmin_talentPool_empty_message: 'Please set search conditions to search',
  luoleAdmin_talentPool_no_results: 'No matching talents found',
  luoleAdmin_talentPool_total_talents: 'Found {{count}} talents',
  luoleAdmin_messageManagement_search_placeholder:
    'Search by subject or sender',
  luoleAdmin_messageManagement_status_all: 'All Status',
  luoleAdmin_messageManagement_status_unread: 'Unread',
  luoleAdmin_messageManagement_status_read: 'Read',
  luoleAdmin_messageManagement_status_replied: 'Replied',
  luoleAdmin_messageManagement_type_all: 'All Types',
  luoleAdmin_messageManagement_type_candidate: 'Candidate',
  luoleAdmin_messageManagement_type_enterprise: 'Enterprise',
  luoleAdmin_messageManagement_type_hunter: 'Hunter',
  luoleAdmin_messageManagement_column_sender: 'Sender',
  luoleAdmin_messageManagement_column_subject: 'Subject',
  luoleAdmin_messageManagement_column_status: 'Status',
  luoleAdmin_messageManagement_column_time: 'Created Time',
  luoleAdmin_messageManagement_reply_placeholder: 'Type your reply',
  luoleAdmin_messageManagement_reply_action: 'Reply',
  luoleAdmin_messageManagement_load_failed: 'Failed to load messages',
  luoleAdmin_messageManagement_reply_success: 'Reply sent',
  luoleAdmin_messageManagement_reply_failed: 'Reply failed',
  luoleAdmin_messageManagement_delete_success: 'Deleted successfully',
  luoleAdmin_messageManagement_delete_failed: 'Delete failed',
  luoleAdmin_messageManagement_delete_confirm: 'Delete this message?',
};
